import { Settings } from '@/store/settings/types';

export const state: Settings = {
    common: null,
    asBuilt: null,
};
